// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar-chart-with-selection {
    display: flex;
    gap: 80px;
    align-items: flex-start;
    padding-left: 150px;
}

.chart-container {
  width: 40%;
}
  
.chart-image {
  max-width: 100%;
  border: 2px solid #ccc;
  border-radius: 5px;
}

.class-selection {
  width: 25%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 70px;
  background-color: #fffacd; /* Yellow background */
}

.class-selection h3 {
  background-color: #ffcc66; /* Header background */
  padding: 10px;
  text-align: center;
}

.class-selection table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.class-selection tr {
  cursor: pointer;
  text-align: center;
}

.class-selection tr.selected {
  background-color: #6495ed; /* Blue color (selected) */
  color: white;
}

.class-selection td {
  padding: 10px;
  border: 1px solid #ccc;
}

.class-selection button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.class-selection button:hover {
  background-color: #45a049;
}

/* Styles for displaying selected classes */
.selected-classes-display {
  margin: 0px auto;
  background-color: #eaf4ff;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 600px;
  border-left: 5px solid #4285f4;
}

.selected-classes-display h3 {
  margin-top: 0;
  font-size: 18px;
  color: #2c5282;
  font-weight: 600;
}

.selected-classes-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.selected-class-item {
  display: flex;
  align-items: center;
  background-color: #e8f1ff;
  border: 1px solid #c8d8ff;
  border-radius: 6px;
  padding: 10px 15px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.selected-class-name {
  font-weight: 600;
  color: #2c5282;
  margin-right: 10px;
  font-size: 16px;
}

.selected-badge {
  background-color: #4285f4;
  color: white;
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.class-column-selector {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin: 20px auto 30px;
  padding: 16px 20px;
  background-color: #eef3ff;
  border: 1px solid #c5d4ff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(66, 133, 244, 0.1);
  max-width: 640px;
}

.class-column-selector label {
  font-weight: 600;
  color: #1a3c8c;
}

.class-column-selector select {
  min-width: 220px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #9bb6ff;
  background-color: #fff;
  font-size: 16px;
  color: #1a3c8c;
}

.class-column-selector select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.class-column-selector__hint {
  flex-basis: 100%;
  margin: 0;
  font-size: 13px;
  color: #4a5ca7;
}`, "",{"version":3,"sources":["webpack://./src/css/step4-selectClass.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,cAAc;AAChB","sourcesContent":[".bar-chart-with-selection {\n    display: flex;\n    gap: 80px;\n    align-items: flex-start;\n    padding-left: 150px;\n}\n\n.chart-container {\n  width: 40%;\n}\n  \n.chart-image {\n  max-width: 100%;\n  border: 2px solid #ccc;\n  border-radius: 5px;\n}\n\n.class-selection {\n  width: 25%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 10px;\n  margin-bottom: 70px;\n  background-color: #fffacd; /* Yellow background */\n}\n\n.class-selection h3 {\n  background-color: #ffcc66; /* Header background */\n  padding: 10px;\n  text-align: center;\n}\n\n.class-selection table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.class-selection tr {\n  cursor: pointer;\n  text-align: center;\n}\n\n.class-selection tr.selected {\n  background-color: #6495ed; /* Blue color (selected) */\n  color: white;\n}\n\n.class-selection td {\n  padding: 10px;\n  border: 1px solid #ccc;\n}\n\n.class-selection button {\n  margin-top: 20px;\n  padding: 10px 20px;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.class-selection button:hover {\n  background-color: #45a049;\n}\n\n/* Styles for displaying selected classes */\n.selected-classes-display {\n  margin: 0px auto;\n  background-color: #eaf4ff;\n  padding: 15px 20px;\n  border-radius: 8px;\n  box-shadow: 0 3px 10px rgba(0,0,0,0.1);\n  width: 100%;\n  max-width: 600px;\n  border-left: 5px solid #4285f4;\n}\n\n.selected-classes-display h3 {\n  margin-top: 0;\n  font-size: 18px;\n  color: #2c5282;\n  font-weight: 600;\n}\n\n.selected-classes-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.selected-class-item {\n  display: flex;\n  align-items: center;\n  background-color: #e8f1ff;\n  border: 1px solid #c8d8ff;\n  border-radius: 6px;\n  padding: 10px 15px;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.selected-class-name {\n  font-weight: 600;\n  color: #2c5282;\n  margin-right: 10px;\n  font-size: 16px;\n}\n\n.selected-badge {\n  background-color: #4285f4;\n  color: white;\n  font-size: 12px;\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n  letter-spacing: 0.3px;\n}\n\n.class-column-selector {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin: 20px auto 30px;\n  padding: 16px 20px;\n  background-color: #eef3ff;\n  border: 1px solid #c5d4ff;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(66, 133, 244, 0.1);\n  max-width: 640px;\n}\n\n.class-column-selector label {\n  font-weight: 600;\n  color: #1a3c8c;\n}\n\n.class-column-selector select {\n  min-width: 220px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #9bb6ff;\n  background-color: #fff;\n  font-size: 16px;\n  color: #1a3c8c;\n}\n\n.class-column-selector select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.class-column-selector__hint {\n  flex-basis: 100%;\n  margin: 0;\n  font-size: 13px;\n  color: #4a5ca7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
